function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.663 2.918a1 1 0 01.085 1.412l-7.68 8.666a1 1 0 01-1.418.08l-4.32-3.9A1 1 0 012.67 7.69l3.571 3.224 7.01-7.912a1 1 0 011.412-.085z",
  fill: "currentColor"
});

function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC42NjMyIDIuOTE4MDlDMTUuMDc2NiAzLjI4NDM4IDE1LjExNDcgMy45MTYzOSAxNC43NDg0IDQuMzI5NzNMNy4wNjg0MyAxMi45OTY0QzYuODkxNDcgMTMuMTk2MSA2LjY0MjA1IDEzLjMxNjggNi4zNzU2NSAxMy4zMzE2QzYuMTA5MjQgMTMuMzQ2NSA1Ljg0Nzk1IDEzLjI1NDIgNS42NDk5IDEzLjA3NTRMMS4zMjk5IDkuMTc1NDVDMC45MTk5NjIgOC44MDUzNiAwLjg4NzY1MiA4LjE3MzAyIDEuMjU3NzQgNy43NjMwOEMxLjYyNzgzIDcuMzUzMTQgMi4yNjAxNyA3LjMyMDgzIDIuNjcwMTEgNy42OTA5MUw2LjI0MDk2IDEwLjkxNDZMMTMuMjUxNiAzLjAwMzNDMTMuNjE3OSAyLjU4OTk1IDE0LjI0OTkgMi41NTE4IDE0LjY2MzIgMi45MTgwOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgCheckbox as ReactComponent };